import axios from "axios";
import { toast } from "react-toastify";
import paths from "routes/paths"; // Assuming paths is defined correctly
import { hideLoader, showLoader } from "./loaderManager";
import { baseUrlInternal } from "./baseUrl";

export const apiInstanceInternal = axios.create({
  baseURL: baseUrlInternal,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Request interceptor
apiInstanceInternal.interceptors.request.use(
  (config) => {
    showLoader();
    const bearerToken = localStorage.getItem("bearerToken");
    if (bearerToken) {
      config.headers.Authorization = `Bearer ${bearerToken}`;
    }
    console.log("Request Config:", config); // Debug request details
    return config;
  },
  (error) => {
    hideLoader();
    console.error("Request Error:", error); // Debug request error
    return Promise.reject(error);
  }
);

// Response interceptor
apiInstanceInternal.interceptors.response.use(
  (response) => {
    hideLoader();
    console.log("Response:", response); // Debug response details
    return response;
  },
  (error) => {
    hideLoader();
    console.error("Response Error:", error.response || error); // Debug response error
    const expectedError =
      error.response?.status >= 400 && error.response?.status < 500;
    const errorMessage =
      error.response?.data?.message || "An unexpected error occurred";

    if (!navigator.onLine) {
      toast.error("Network error - please check your internet connection");
      return Promise.reject({ message: "Network Error" });
    }

    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = paths.login;
    }

    if (error.response?.status === 404) {
      toast.error("API endpoint not found. Please contact support.");
    }

    if (error.response?.status === 0) {
      toast.error("CORS error or server not responding.");
    }

    return Promise.reject(errorMessage);
  }
);

export default apiInstanceInternal;
